import { render, staticRenderFns } from "./output-clipboard-table.html?vue&type=template&id=465a709d&scoped=true&"
import script from "./output-clipboard-table.js?vue&type=script&lang=js&"
export * from "./output-clipboard-table.js?vue&type=script&lang=js&"
import style0 from "./output-clipboard-table.scss?vue&type=style&index=0&id=465a709d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465a709d",
  null
  
)

export default component.exports